import React from 'react';
import { Alert } from 'antd';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faCircleExclamation,
  faCircleXmark,
  faLightbulb,
} from '@fortawesome/pro-regular-svg-icons';
import { AlertProps } from 'antd/lib';
import { css } from 'styled-components';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';

type DevExAlertProps = AlertProps;

export const DevExAlert: React.FC<DevExAlertProps> = (props) => {
  const theme = useDevExTheme();
  type TypesPropKeys = Exclude<AlertProps['type'], undefined>;
  const colorsByType: {
    [key in TypesPropKeys]: {
      background: string;
      text: string;
      border: string;
    };
  } = {
    info: theme.color.status.info,
    warning: theme.color.status.warning,
    error: theme.color.status.error,
    success: theme.color.status.success,
  };

  const iconByType: { [key in TypesPropKeys]: IconProp } = {
    info: faLightbulb,
    warning: faCircleExclamation,
    error: faCircleXmark,
    success: faCheckCircle,
  };
  const colortheme = props.type ? colorsByType[props.type] : undefined;
  const icon = props.icon ? props.icon : props.type ? iconByType[props.type] : undefined;
  return (
    <Alert
      {...props}
      icon={icon}
      css={css`
    &&&&.ant-alert {
      ${
        colortheme &&
        `
        border-color: ${colortheme.border};
        background-color: ${colortheme.background};
        color: ${colortheme.text};
        .ant-alert-icon {
          color: ${colortheme.text};
        }
      `
      }`}
    />
  );
};
